import React, { useEffect } from "react";
import { Modal, Form, Input, Select } from "antd";
import { create_pos_from_route } from "../../../../../../../api/endpoints/agents";
import PhoneInput from "../../../../../../common/phone-input/PhoneInput";
import { COLORS } from "../../../../../../layout/theme";

export default function CreatePosModal({
	open,
	onCancel,
	onSuccess,
	agentRouteId,
	defaultCuit,
	defaultName,
}) {
	const [form] = Form.useForm();

	useEffect(() => {
		if (open) {
			form.setFieldsValue({
				cuit: defaultCuit || "",
				name: defaultName || "",
			});
		}
	}, [open]);

	const onOk = async () => {
		const values = await form.validateFields();
		const payload = {
			agentRouteId,
			cuit: values.cuit?.trim(),
			name: values.name?.trim(),
			phone: `${values.phoneAreaCode}${values.phone}`.replace(/[\/?#*\-]/g, ""),
			whatsappUserId:
				"54911" + values.whatsappUserId?.replace(/\D/g, "").slice(-8),
		};
		await create_pos_from_route(payload);
		onSuccess?.();
		onCancel();
	};

	return (
		<Modal
			open={open}
			title="Crear nuevo Punto de Venta"
			okText="Crear y validar"
			cancelText="Cancelar"
			onCancel={onCancel}
			onOk={onOk}
			destroyOnClose
		>
			<Form form={form} layout="vertical">
				<Form.Item
					label="CUIT"
					name="cuit"
					rules={[{ required: true, message: "Ingresá el CUIT" }]}
				>
					<Input maxLength={20} />
				</Form.Item>

				<Form.Item
					label="Nombre / Razón Social"
					name="name"
					rules={[{ required: true, message: "Ingresá el nombre" }]}
				>
					<Input maxLength={120} />
				</Form.Item>

				<PhoneInput
					form={form}
					size="default"
					label="Teléfono de Contacto"
					labelStyle={{
						color: COLORS.Primary,
						fontWeight: "600",
					}}
				/>

				<Form.Item
					label="Whatsapp"
					name="whatsappUserId"
					rules={[
						{
							required: true,
							message: "Este campo es obligatorio",
						},
						{
							pattern: new RegExp(/^(?!\s*$)[0-9\s]*$/),
							message: "No se aceptan caracteres especiales. Solo numeros",
						},
					]}
				>
					<Input maxLength={120} addonBefore="54911" />
				</Form.Item>
			</Form>
		</Modal>
	);
}
